import { UserRole } from "@joonapp/web-shared"
import { QuestStatus } from "@joonapp/web-shared"

import { createJoonAPIClient } from "../../util/joon-api"

export const getCoinsReadyToRedeem = async (userId: number) => {
  const API = createJoonAPIClient()
  const result = await API.get(`/api/quest-instances/`, {
    params: {
      user_id: userId,
      role: UserRole.PARENT,
      status: QuestStatus.VERIFIED,
    },
  })

  let total = 0
  for (const instance of result.data.results) {
    total += instance.redeemable_reward || 0
  }
  return total
}

export const setQuestInactive = async (questSeriesId: number) => {
  const API = createJoonAPIClient()
  return API.post(`/api/quest-series/${questSeriesId}/inactivate/`)
}

export const setQuestActive = async (questSeriesId: number) => {
  const API = createJoonAPIClient()
  return API.post(`/api/quest-series/${questSeriesId}/activate/`)
}
